import { ChangeEvent } from 'react';
import { SelectChangeEvent, Stack, styled, Typography } from '@mui/material';
import { TableCustom } from 'app/components/elements/TableCustom';
import { InputSelect } from 'app/components/elements/InputSelect';
import { InputText } from 'app/components/elements/InputText';
import {
  IssuesFiltersBar,
  IssuesFilterField,
  IssuesSearchField,
  filterFieldSx
} from 'app/pages/IssuesPage/components/IssuesFiltersBar';
import { useAssetDueInjection } from './hook';
import {
  buildMaintenanceRow,
  exportMaintenanceCsv,
  MAINTENANCE_TABLE_HEADERS,
  useMaintenanceTableFilters
} from '../shared/maintenanceTable';

export const AssetDue = () => {
  const { devices, loading } = useAssetDueInjection();
  const {
    search,
    setSearch,
    client,
    setClient,
    clientOptions,
    location,
    setLocation,
    locationOptions,
    triggerType,
    setTriggerType,
    triggerTypeOptions,
    filteredDevices,
    hasActiveFilters,
    clearFilters
  } = useMaintenanceTableFilters(devices);

  const dataTable = filteredDevices.map(buildMaintenanceRow);

  return (
    <TabContentContainer>
      <Typography fontSize={24} fontWeight={700} color="#226AAA">
        Assets Due
      </Typography>

      <IssuesFiltersBar
        showClearFilters={hasActiveFilters}
        onClearFilters={clearFilters}
        onExportCsv={() => exportMaintenanceCsv('assets-due', filteredDevices)}>
        <IssuesSearchField>
          <InputText
            placeholder="Search asset, client, location, IoT device…"
            inputProps={{
              value: search,
              onChange: (e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value),
              style: { minHeight: '46px', height: '46px', padding: 0 }
            }}
          />
        </IssuesSearchField>
        <IssuesFilterField>
          <InputSelect
            placeholder="All Clients"
            sx={filterFieldSx}
            value={client}
            onChange={(e: SelectChangeEvent<unknown>) =>
              setClient((e.target.value as string) || '')
            }
            options={clientOptions}
          />
        </IssuesFilterField>
        <IssuesFilterField>
          <InputSelect
            placeholder="All Locations"
            sx={filterFieldSx}
            value={location}
            onChange={(e: SelectChangeEvent<unknown>) =>
              setLocation((e.target.value as string) || '')
            }
            options={locationOptions}
          />
        </IssuesFilterField>
        <IssuesFilterField>
          <InputSelect
            placeholder="All Trigger Types"
            sx={filterFieldSx}
            value={triggerType}
            onChange={(e: SelectChangeEvent<unknown>) =>
              setTriggerType((e.target.value as string) || '')
            }
            options={triggerTypeOptions}
          />
        </IssuesFilterField>
      </IssuesFiltersBar>

      {!loading && filteredDevices.length === 0 ? (
        <Typography color="#6B7280">No assets are currently due for maintenance.</Typography>
      ) : (
        <TableCustom
          handleChooseRow={() => {}}
          headers={MAINTENANCE_TABLE_HEADERS}
          data={dataTable}
          isScrollX
        />
      )}
    </TabContentContainer>
  );
};

const TabContentContainer = styled(Stack)(() => ({
  flex: 1,
  gap: 10,
  paddingTop: 40,
  paddingBottom: 40
}));
